var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddReaction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6 A7 7 0 1 0 18 13"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.9,
    cy: 11.5,
    r: 0.9,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.9,
    cy: 11.5,
    r: 0.9,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9 14.5C8.5 15.7 9.6 16.3 10.9 16.3C12.2 16.3 13.3 15.7 13.9 14.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 4,
    x2: 17,
    y2: 10,
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 7,
    x2: 20,
    y2: 7,
    strokeWidth: 2.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddReaction);
export default __webpack_public_path__ + "static/media/add-reaction.4115fced61dce36f017c7afbe875b074.svg";
export { ForwardRef as ReactComponent };